


























































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { masterEditionModule } from '../store/modules/MasterEdition'; // ストアモジュール
import { KanriConstants } from '../fixed/KanriConstants';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { IMasterEdition, IMasterEditionKey } from '../store/dto/MasterEdition';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.07.04 [2023F-02] add
 */
@Component
export default class MasterEditionSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [{}];
  // ボタン表示設定
  private deleteAuthority: boolean = false;
  private createAuthority: boolean = false;
  private updateAuthority: boolean = false;

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '申請受付期間管理';
    // 権限設定
    this.deleteAuthority = this.checkAuthority(AuthoritiesId.MST_DELETE);
    this.createAuthority = this.checkAuthority(AuthoritiesId.MST_CREATE);
    if (this.checkAuthority(AuthoritiesId.MST_UPDATE) || this.checkAuthority(AuthoritiesId.ROLE_CYDEEN2_ADMIN)) {
      this.updateAuthority = true;
    } else {
      this.updateAuthority = false;
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['master_edition_search_condition']);
    const path: string = KanriConstants.EDITION_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 先頭の空白列削除
        this.headers.shift();
        // ボタン用ヘッダ
        this.headers.push(
        {text: '削除', align: 'center', sortable: false, value: 'delete', width: 90},
        );
        // 検索結果.DBから展開
        for (const item of this.variablecols['master_edition_search_result'] ) {
          this.headers.push({text: item.label,
                            align: item.align,
                            sortable: item.sortable,
                            value: item.name,
                            width: item.width,
                            } );
        }
        // 再検索
        if (masterEditionModule.GET_IS_FORM_CONDITION_SETTING) {
          this.formData = masterEditionModule.GET_FORM_CONDITION;
          this.syncFormDataToVariableCols();
          this.search();
        }
      }
    });

  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    // 申請受付期間情報削除
    masterEditionModule.moduleReset();
    router.push({ name: 'kanri-top' });
  }

  /**
   * 検索
   */
  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(KanriConstants.EDITION_PATH, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        masterEditionModule.setFormCondition(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('masterEditionSearch', -50);
      }
    });
  }

  /**
   * 登録画面への遷移
   */
  private addData() {
    router.push({ name: 'masterEditionInfo' });
  }

  // /**
  //  * 検索条件のクリア
  //  */
  // private reset() {
  //   this.resetForm(this.$refs.form);
  //   this.resultData = [];
  //   this.search;
  // }

  /**
   * 申請受付期間の削除
   * @param traderType
   * @param nendo
   */
  private deleteData(argTraderType: string, argNendo: string) {
    const param: IMasterEditionKey = {
        traderType: argTraderType,
        nendo: argNendo,
    };
    if (window.confirm(Message.I0001)) {
      masterEditionModule.setMasterEdition(param);
      // APIアクセス
      this.apiAccess(
        KanriConstants.EDITION_PATH + '/delete' + masterEditionModule.GET_PATH
           , Constants.API_METHOD_POST, false, null)
      .then((result) => {
        this.hrefElement('masterEditionSearch', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          // キー情報削除
          masterEditionModule.moduleSelectReset();
          // 結果から削除したデータを削除
          for (const rowIndex of Object.keys(this.resultData)) {
            if (this.resultData[Number(rowIndex)]['traderTypeCode'] === param.traderType
            && this.resultData[Number(rowIndex)]['nendo'] === param.nendo) {
              this.resultData.splice(Number(rowIndex), 1);
            }
          }
        } else {
          // キー情報削除
          masterEditionModule.moduleSelectReset();
        }
      });
    }
  }

  /**
   * 申請受付期間の編集
   * @param traderType
   * @param nendo
   */
  private editData(argTraderType: string, argNendo: string) {
    const param: IMasterEditionKey = {
        traderType: argTraderType,
        nendo: argNendo,
    };
    masterEditionModule.setMasterEdition(param);
    if (this.updateAuthority) {
      this.apiAccess(KanriConstants.EDITION_PATH + masterEditionModule.GET_EXCLUSIVE_PATH, Constants.API_METHOD_POST, false, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          router.push({ name: 'masterEditionInfo' });
        } else {
          // キー情報削除
          masterEditionModule.moduleSelectReset();
          this.hrefElement('masterEditionSearch', -50);
        }
      });
    } else {
      router.push({ name: 'masterEditionInfo' });
    }
  }
}
